import { Link } from "react-router-dom";
//#region src/modules/header/utils/breadcrumbs.ts
var findPathToNode = (items, currentPath) => {
	for (const item of items) {
		if (item.uri === currentPath) return [item];
		if (item.children && item.children.length > 0) {
			const childPath = findPathToNode(item.children, currentPath);
			if (childPath) return [item, ...childPath];
		}
	}
	return null;
};
var findProductLabel = (menu, product) => menu.find((it) => it.product === product);
var buildBreadcrumb = (item, isLastItem) => {
	let Component = "span";
	let componentProps = {};
	if (!isLastItem && item.uri) if (item.external) {
		Component = "a";
		componentProps = {
			href: `${item.baseUri}${item.uri}`,
			rel: "noopener noreferrer",
			target: "_self"
		};
	} else {
		Component = Link;
		componentProps = { to: item.uri };
	}
	return {
		title: item.label,
		Component,
		componentProps
	};
};
var generateBreadcrumbs = (menu, currentPath, currentProduct) => {
	const pathItems = findPathToNode(menu, currentPath);
	if (!pathItems) {
		const product = findProductLabel(menu, currentProduct);
		if (product) return [buildBreadcrumb(product, false)];
		return [];
	}
	return pathItems.map((item, index) => {
		return buildBreadcrumb(item, index === pathItems.length - 1);
	});
};
//#endregion
export { generateBreadcrumbs };
